/**
 * Format a merchant_regions.baseRate for display in the Stores list.
 *
 * Rates are stored in PERCENTAGE units to 4 dp (backbone numeric(6,4)), e.g.
 * 5.0000 = 5%. We respect that precision in the data but display sensibly:
 * trim trailing zeros and append '%'. So 5.0000 -> "5%", 2.5000 -> "2.5%",
 * 1.2500 -> "1.25%". A missing / non-numeric rate renders as an em dash.
 */
export const formatRate = (rate: unknown): string => {
  const n = Number(rate);
  if (rate === null || rate === '' || !Number.isFinite(n)) return '—';
  const trimmed = n.toFixed(4).replace(/\.?0+$/, '');
  return `${trimmed}%`;
};
